import { Route, Switch } from "@hyperapp/router";
import { h } from "hyperapp";

import { mainNavbar } from "../common/main-navbar/main-navbar";
import { main as places } from "../sections/places/main";
import { main as scheduling } from "../sections/scheduling/main";
import { main as unvisitedPlaces } from "../sections/unvisited-places/main";
import { main as unvisitedPlacesNearby } from "../sections/unvisited-places-nearby/main";

export const topbar = ({ actions, state, translations }) => {
  return (
    <Switch>
      {Route({
        path: "/",
        render: () => (
          <div>
            {mainNavbar({ state })}
            {places({
              actions,
              section: "places",
              state,
              translations: translations.translations,
            })}
          </div>
        ),
      })}
      {Route({
        path: "/unvisited-places",
        render: () => (
          <div>
            {mainNavbar({ state })}
            {unvisitedPlaces({
              actions,
              section: "unvisitedPlaces",
              state,
              translations:
                translations.translations["unvisitedPlaces"][state.language],
            })}
          </div>
        ),
      })}
      {Route({
        path: "/unvisited-places/nearby",
        render: () => (
          <div>
            {mainNavbar({ state })}
            {unvisitedPlacesNearby({
              actions,
              section: "unvisitedPlacesNearby",
              state,
              translations:
                translations.translations["unvisitedPlacesNearby"][
                  state.language
                ],
            })}
          </div>
        ),
      })}
      {Route({
        path: "/scheduling",
        render: () =>
          scheduling({
            actions,
            section: "scheduling",
            state,
          }),
      })}
    </Switch>
  );
};
